/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { KTIcon, toAbsoluteUrl } from '../../../helpers';

type Props = {
  className: string;
};

const TablesWidget5: React.FC<Props> = ({ className }) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5 d-flex justify-content-between align-items-center'>
        <div>
          <h3 className='card-title fw-bold fs-3 mb-1'>Leaves Request for Approval</h3>
          <span className='text-muted mt-1 fw-semibold fs-7'>Number of Requests</span>
        </div>
        <div className='card-toolbar'>
          {/* Toolbar (if needed) */}
        </div>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='tab-content'>
          {/* begin::Tap pane */}
          <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-striped table-hover align-middle'>
                {/* begin::Table head */}
                <thead>
                  <tr>
                    <th className='min-w-120px'>Employee</th>
                    <th className='text-end min-w-100px'>Leave Type</th>
                    <th className='text-end min-w-100px'>Status</th>
                  </tr>
                </thead>
                {/* end::Table head */}

                {/* begin::Table body */}
                <tbody>
                  {[
                    { name: 'Brad Simmons', type: 'Sick Leave', status: 'Pending', badge: 'warning' },
                    { name: 'John Doe', type: 'Sick Leave', status: 'Pending', badge: 'warning' },
                    { name: 'John Doe', type: 'Urgent Work', status: 'Rejected', badge: 'danger' },
                    { name: 'John Doe', type: 'Sick Leave', status: 'Rejected', badge: 'danger' },
                    { name: 'John Doe', type: 'Sick Leave', status: 'Pending', badge: 'warning' },
                  ].map((request, index) => (
                    <tr key={index}>
                      <td>
                        <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                          {request.name}
                        </a>
                      </td>
                      <td className='text-end text-muted fw-semibold'>{request.type}</td>
                      <td className='text-end'>
                        <span className={`badge badge-light-${request.badge}`}>{request.status}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
          {/* end::Tap pane */}
        </div>
      </div>
      {/* end::Body */}
    </div>
  );
};

export { TablesWidget5 };
